import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  // *Takes 5 parameters
  // 1. Message
  // 2. action
  // duration
  // OPTIONAL horizontalPosition
  // OPTIONAL VerticalPosition

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    hPosition?: MatSnackBarHorizontalPosition,
    vPosition?: MatSnackBarVerticalPosition,
    className?: string
  ): any {
    // if values not given
    if (!hPosition) hPosition = 'center';
    if (!vPosition) vPosition = 'bottom';

    this.snackBar.open(message, action, {
      // tslint:disable-next-line:object-literal-shorthand
      duration: duration,
      horizontalPosition: hPosition,
      verticalPosition: vPosition,
      panelClass: className,
    });
  }
}
